<template>
  <Navbar />
  <div class="home">
    <div class="header">
      <div class="header-overlay"></div>
      <div class="header-content">
        <div class="hero-content">
          <h1>
            Transform Your Business with <strong style="color: #00C896">Posa</strong>
          </h1>
          <p>Experience our flagship SAAS platform that helps businesses record sales, manage inventory, setup online stores, and eliminate fraud from your Business.</p>
          <div class="hero-buttons">
            <a href="https://www.getposa.com" target="_blank" class="btn-primary">Try Posa →</a>
            <a href="#" @click.prevent="schedule_meeting()" class="btn-secondary">Schedule a meeting →</a>
          </div>
        </div>
      </div>
    </div>
    <div class="trusted">
      <h3>Trusted By</h3>
      <div class="trusted-logos">
        <div class="logo-item">
          <img src="../assets/images/google-logo.svg" alt="Google" />
        </div>
        <div class="logo-item">
          <span class="text-logo">ANITA BORG</span>
        </div>
        <div class="logo-item">
          <img src="../assets/images/fame_star.png" alt="Fame Star" />
        </div>
      </div>
    </div>

    <div class="what-we-do">
      <h3 class="title">Our Flagship Product</h3>
      <div class="services-grid">
        <div class="service-card" @click="openPosa">
          <div class="service-icon">
            <i class="fas fa-store"></i>
          </div>
          <h5>Posa - Business Management Platform</h5>
          <p>Our flagship SAAS platform that revolutionizes how businesses manage operations. Record sales, track inventory, setup online stores, and eliminate fraud across mobile, desktop, and tablet platforms.</p>
          <div class="service-arrow">→</div>
        </div>
        <div class="service-card">
          <div class="service-icon">
            <i class="fas fa-chart-line"></i>
          </div>
          <h5>Sales Recording</h5>
          <p>Comprehensive sales tracking and recording system to monitor transactions, generate reports, and gain insights into your business performance.</p>
          <div class="service-arrow">→</div>
        </div>
        <div class="service-card">
          <div class="service-icon">
            <i class="fas fa-boxes"></i>
          </div>
          <h5>Inventory Management</h5>
          <p>Real-time inventory tracking and management to optimize stock levels, reduce waste, and ensure product availability when customers need it.</p>
          <div class="service-arrow">→</div>
        </div>
        <div class="service-card">
          <div class="service-icon">
            <i class="fas fa-shopping-cart"></i>
          </div>
          <h5>Online Store Setup</h5>
          <p>Create and manage your online storefront with ease. Sell products online, manage orders, and reach customers across all digital channels.</p>
          <div class="service-arrow">→</div>
        </div>
        <div class="service-card">
          <div class="service-icon">
            <i class="fas fa-shield-alt"></i>
          </div>
          <h5>Fraud Prevention</h5>
          <p>Advanced fraud detection and prevention systems to protect your business from fraudulent transactions and unauthorized access.</p>
          <div class="service-arrow">→</div>
        </div>
        <div class="service-card">
          <div class="service-icon">
            <i class="fas fa-mobile-alt"></i>
          </div>
          <h5>Multi-Platform Access</h5>
          <p>Access your business management tools seamlessly across mobile, desktop, and tablet devices for maximum flexibility and convenience.</p>
          <div class="service-arrow">→</div>
        </div>
      </div>
    </div>

    <div class="hire">
      <div class="hire-text col-md-5 col-sm-12">
        <h1>
          Complete <span style="color: #00C896">POS Hardware</span> Solutions
        </h1>
        <p>
          Transform your business with our powerful, easy-to-use POS hardware that works seamlessly together. From industrial tablets and thermal printers to complete POS bundles, our hardware solutions are preloaded with the POSA app and designed to streamline your operations.
        </p>
        <div class="btn12">
          <a href="https://getposa.com/hardware" target="_blank">Explore Hardware →</a>
        </div>
      </div>
      <div class="hire-img col-md-6 col-sm-12">
        <img src="/static/assets/images/tab-and-printer.jpg" alt="Posa Hardware" style="width: 100%; height: 100%; object-fit: contain;" />
      </div>
    </div>
    <div class="bottom">
      <span></span>
      <span></span>
    </div>
    <Footer />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Navbar from "../components/Navbar.vue";
import Footer from "../components/Footer.vue";
// import required modules
import { Autoplay, Pagination, Navigation } from "swiper";
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
export default defineComponent({
  /* eslint-disable */
  name: "Home",
  components: {
    Navbar,
    Footer,
    Swiper,
    SwiperSlide,
  },
  setup() {
    function schedule_meeting() {
      (window as any).Calendly.showPopupWidget("https://calendly.com/grandilo-calistus/30mins");
    }

    function openPosa() {
      window.open("https://www.getposa.com", "_blank");
    }

    return {
      schedule_meeting,
      openPosa,
      modules: [Autoplay, Pagination, Navigation],
    };
  },
});
</script>

<style scoped>
.header {
  width: 100%;
  margin: auto;
  min-height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  padding: 80px 20px;
  background-image: url(../assets/images/tab-and-printer.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.header-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(26, 26, 26, 0.85) 0%, rgba(0, 200, 150, 0.15) 100%);
  z-index: 1;
}

.header-content {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.hero-content {
  color: #ffffff;
  max-width: 600px;
}

.hero-content h1 {
  font-weight: 700;
  font-size: 60px;
  line-height: 1.2;
  margin-bottom: 20px;
}

.hero-content p {
  font-weight: 300;
  font-size: 20px;
  line-height: 1.6;
  margin-bottom: 40px;
  color: #cccccc;
}

.hero-buttons {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.btn-primary {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  border: none;
  outline: none;
  padding: 17px 35px;
  text-align: center;
  background: #00C896;
  color: #ffffff;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background-color: #00B085;
  transform: translateY(-2px);
}

.btn-secondary {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  border: 1px solid #00C896;
  outline: none;
  padding: 17px 35px;
  text-align: center;
  background: transparent;
  color: #ffffff;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  background-color: #00C896;
  color: #ffffff;
}

.trusted {
  background: rgb(8, 61, 55);
  padding: 60px 0;
  color: #ffffff;
}

.trusted h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  text-align: center;
  margin-bottom: 40px;
  color: #ffffff;
}

.trusted-logos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  flex-wrap: wrap;
  max-width: 1000px;
  margin: 0 auto;
}

.logo-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.logo-item img {
  max-width: 120px;
  max-height: 60px;
  filter: brightness(0) invert(1);
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.logo-item:hover img {
  opacity: 1;
}

.text-logo {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 1px;
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.logo-item:hover .text-logo {
  opacity: 1;
}

.title {
  margin: 90px 0 20px 0;
  font-weight: 600;
  font-size: 40px;
  text-align: center;
  color: #333333;
}

.what-we-do {
  background-color: #ffffff;
  padding: 80px 0;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.service-card {
  background: #f8f9fa;
  padding: 30px 20px;
  border-radius: 10px;
  text-align: center;
  color: #333333;
  position: relative;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid #e9ecef;
}

.service-card:hover {
  transform: translateY(-5px);
  background: #00C896;
  border-color: #00C896;
  box-shadow: 0 10px 30px rgba(0, 200, 150, 0.2);
}

.service-icon {
  font-size: 48px;
  color: #00C896;
  margin-bottom: 20px;
  transition: color 0.3s ease;
}

.service-card:hover .service-icon {
  color: #ffffff;
}

.service-card h5 {
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 15px;
  color: #333333;
  transition: color 0.3s ease;
}

.service-card:hover h5 {
  color: #ffffff;
}

.service-card p {
  font-weight: 300;
  font-size: 14px;
  line-height: 1.6;
  color: #666666;
  margin-bottom: 20px;
  transition: color 0.3s ease;
}

.service-card:hover p {
  color: #ffffff;
}

.service-arrow {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 20px;
  color: #00C896;
  opacity: 0.7;
  transition: all 0.3s ease;
}

.service-card:hover .service-arrow {
  color: #ffffff;
  opacity: 1;
  transform: translateX(5px);
}

.hire {
  width: 100%;
  display: flex;
  background-color: #1A1A1A;
  padding: 80px 0;
  align-items: center;
}
.hire-text {
  margin: auto;
  margin-left: 70px;
  text-align: left;
  color: #ffffff;
}
.hire-text p {
  text-align: left;
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  width: 90%;
  color: #cccccc;
  line-height: 1.6;
}
.hire-text h1 {
  width: 90%;
  font-weight: 700;
  font-size: 44px;
  color: #ffffff;
  line-height: 1.2;
  margin-bottom: 20px;
}
.hire-text a {
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  padding: 17px 35px;
  text-align: center;
  color: #ffffff;
  border: none;
  background-color: #00C896;
  border-radius: 5px;
  transition: all 0.3s ease;
}
.hire-text a:hover {
  background-color: #00B085;
  transform: translateY(-2px);
}
.hire-img {
  height: 400px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  overflow: hidden;
}

.hire-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 10px;
}
.bottom {
  text-align: right;
  display: flex;
  justify-content: right;
  margin-top: -150px;
  overflow: hidden;
  margin-bottom: -150px;
}
.bottom span {
  width: 13px;
  height: 200px;
  transform: rotate(45deg);
  background-color: #199a8b;
}
.bottom span:first-child {
  height: 350px;
  margin-right: 45px;
  margin-top: -40px;
  border-top-right-radius: 20px;
}
.bottom span:last-child {
  height: 250px;
  margin-right: 50px;
  border-top-right-radius: 20px;
}
@media screen and (max-width: 820px) {
  .header {
    flex-direction: column;
    padding: 40px 20px;
    min-height: auto;
    background-attachment: scroll;
  }
  
  .header-content {
    justify-content: center;
    text-align: center;
  }
  
  .hero-content {
    text-align: center;
  }
  
  .hero-content h1 {
    font-size: 32px;
    text-align: center;
  }
  
  .hero-content p {
    font-size: 16px;
    text-align: center;
  }
  
  .hero-buttons {
    justify-content: center;
    flex-direction: column;
    gap: 15px;
  }
  
  .btn-primary,
  .btn-secondary {
    width: 100%;
    max-width: 250px;
    margin: 0 auto;
  }
  
  .services-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  
  
  
  .trusted-logos {
    gap: 30px;
  }
  
  .logo-item img {
    max-width: 80px;
    max-height: 40px;
  }
  
  .hire {
    flex-direction: column;
    padding: 40px 20px;
  }
  
  .hire-text {
    margin: 0;
    text-align: center;
    margin-bottom: 30px;
  }
  
  .hire-text h1 {
    font-size: 28px;
  }
  
  .hire-text p {
    font-size: 16px;
  }
  
  .hire-img {
    height: 250px;
    width: 100%;
    margin: 0;
  }
}
</style>
